import * as Actions from '../../actions/coupon/coupon';
export default function selectedBetTypeReducer(state, action) {
    switch (action.type) {
        case Actions.SELECT_BET_TYPE:
            return action.data;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/coupon/selectedBetTypeReducer.js